
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral/[...code]",
      function () {
        return require("private-next-pages/referral/[...code].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral/[...code]"])
      });
    }
  